// extracted by mini-css-extract-plugin
export default {"paypalButtonPlaceholder":"PayPalButtonPlaceholder-module__paypalButtonPlaceholder___TsWwN"};